import script from "./RegistrationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationComponent.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationComponent.vue?vue&type=style&index=0&id=58ef8a46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ef8a46"]])

export default __exports__